var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6V4L12 4L12 0L10 0L10 4L6 4L6 0L4 0L4 4L0 4L0 6L4 6L4 10L0 10L0 12L4 12L4 16H6L6 12H10V16H12V12H16L16 10H12V6L16 6ZM10 10H6L6 6L10 6V10Z",
    fill: "#42495E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashIcon);
export default __webpack_public_path__ + "static/media/HashIcon.5eb32642.svg";
export { ForwardRef as ReactComponent };